export default __webpack_public_path__ + "static/media/cebrac.c627651e.png";